// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Zryl","col":"styles_col__bTqYN","actions":"styles_actions__2j7AA","conflict":"styles_conflict__1B-0-"};